import { TotalProjectHours } from '../interfaces/total-project-hours.interface';

export interface IProjectJson {
    id?: string;
    name: string;
    externalContact: string;
    internalContact: string;
    projectLead: string;
    startDate: string;
    endDate?: string;
    notes: string;
    status: string;
    clientId: string;
    estimatedHours: number | null;
    nonBillable: boolean;
    totalProjectHours?: TotalProjectHours;
}

interface IProjectConstructor {
    id?: string;
    name: string;
    externalContact: string;
    internalContact: string;
    projectLead: string;
    startDate: string;
    endDate?: string;
    notes: string;
    status: string;
    clientId: string;
    estimatedHours: number | null;
    nonBillable: boolean;
    totalProjectHours?: TotalProjectHours;
}

export interface Project extends IProjectConstructor {
    id?: string;
    name: string;
    externalContact: string;
    internalContact: string;
    projectLead: string;
    startDate: string;
    endDate?: string;
    notes: string;
    status: string;
    clientId: string;
    estimatedHours: number | null;
    nonBillable: boolean;
    totalProjectHours?: TotalProjectHours;
}

export class Project {
    constructor(input: IProjectConstructor) {
        Object.assign(this, input);
    }

    static fromJson(json: IProjectJson): Project | null {
        if (json == null) {
            return null;
        }

        return new Project({
            ...json,
        });
    }
}
